export const RefreshIcon = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    fill="none"
    viewBox="0 0 14 15"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12.25 6.333S11.08 4.74 10.13 3.79a5.25 5.25 0 1 0 1.331 5.17m.79-2.626v-3.5m0 3.5h-3.5"
    />
  </svg>
);
